export default "__VITE_ASSET__7p_CwZW9__"